import tail from "ramda/src/tail";
import toUpper from "ramda/src/toUpper";

export const capitalize = (s: string) =>
  s.length ? toUpper(s[0]) + tail(s) : "";

export const prettyPrint = <T extends Record<string, any>>(s: T) =>
  JSON.stringify(s, null, "  ");
